namespace Dialog.LoginTotp {

  export interface TotpChallengeResponse {
    /** The user's session id. */
    sessionGuid: string;
    /** Url to the LoginActions page */
    loginActionsUrl: string;
    /** Markup for the (localized) TOTP dialog */
    totpDialogHtml: string;
    /** Authorize result from SSO, requiring TOTP */
    ssoAuthResult: object;
    /** The password provided by the user that cleared the password check. */
    userProvidedPassword: string;
  }

  interface TotpForm {
    totp: string;
  }

  class RespondToTotpChallengeRequest extends G2.ClientSessionRequest {
    constructor(public form: TotpForm, public ssoAuthenticateResult: object) {
      super("RespondToTotpChallenge");
    }
  }

  interface RespondToTotpChallengeResponse extends G2.ServerResponse {
    invalidProperties: G2.InvalidProperties;
  }

  class SendResetMfaEmailRequest extends G2.ClientSessionRequest {
    constructor(public ssoAuthenticateResult: object) {
      super("SendResetMfaEmail");
    }
  }

  interface SendResetMfaEmailResponse extends G2.ServerResponse {
    resetMfaCodeKey: string;
  }

  class ResetMfaRequest extends G2.ClientSessionRequest {
    constructor(public ssoAuthenticateResult: object, public resetMfaCodeKey: string, public totpForm: TotpForm, public userProvidedPassword: string) {
      super("ResetMfa");
    }
  }

  interface ResetMfaResponse extends G2.ServerResponse {
    invalidProperties: G2.InvalidProperties;
  }

  let Dialog: G2.BoundDialog<TotpForm>;
  let TotpChallengeResponse: TotpChallengeResponse;

  /** The reset code emailed to the user.  If null, the reset code has not yet been sent. */
  let ResetMfaCodeKey: string = null;

  function ResetCheckbox() { return Dialog.BoundForm.Container().find("#login-mfa-reset-checkbox"); }

  export function Open(r: TotpChallengeResponse) {
    TotpChallengeResponse = r;
    Server.SetSessionGuid(r.sessionGuid);

    Dialog = new G2.BoundDialog($(r.totpDialogHtml), { wijmo: { hideTrigger: wijmo.input.PopupTrigger.None } });
    Dialog.Control().hiding.addHandler((_, e) => { e.cancel = true }); // prevent closing dialog
    Dialog.BoundForm.Container().find("button").on(G2.EventMouse.Click, OkClick);
    Dialog.BoundForm.Tag(f => f.totp).on("input", evt => {
      const totp = $(evt.target).val() as string;
      if (totp.length === 6) {
        OkClick();
      }
    });
    ShowReset(false);
    Dialog.Show();

    ResetCheckbox().on(G2.EventGeneric.Change, () => {
      if (!IsReset()) {
        ShowReset(false); // If checkbox cleared go back to MFA request form
        ResetMfaCodeKey = null; // And forget any code sent
        Dialog.BoundForm.SetProperties({totp: ""});
      }
    });
  }

  /** Handler for click of both the button to enter TOTP and that to enter a reset code. */
  function OkClick() { //NOSONAR
    if (IsReset()) {
      // We are processing an MFA reset
      if (ResetMfaCodeKey) {
        // We have sent the reset code via email
        if (Dialog.BoundForm.Validate()) {
          const totpForm = Dialog.BoundForm.GetProperties();
          Server.Post<ResetMfaResponse>(new ResetMfaRequest(TotpChallengeResponse.ssoAuthResult, ResetMfaCodeKey, totpForm, TotpChallengeResponse.userProvidedPassword))
            .then(r => {
              if (Dialog.BoundForm.SetProperties(totpForm, r.invalidProperties)) {
                location.replace(TotpChallengeResponse.loginActionsUrl);
              }
            });
        }
      } else {
        // We need to send the reset code via email
        Server.Post<SendResetMfaEmailResponse>(new SendResetMfaEmailRequest(TotpChallengeResponse.ssoAuthResult))
          .then(r => {
            ResetMfaCodeKey = r.resetMfaCodeKey;
            ShowReset(true);
          });
      }
    } else {
      // We are processing a TOTP
      if (Dialog.BoundForm.Validate()) { //NOSONAR
        const form = Dialog.BoundForm.GetProperties();
        Server.Post<RespondToTotpChallengeResponse>(new RespondToTotpChallengeRequest(form, TotpChallengeResponse.ssoAuthResult))
          .then(r => {
            if (Dialog.BoundForm.SetProperties(form, r.invalidProperties)) {
              location.replace(TotpChallengeResponse.loginActionsUrl);
            }
          });
      }
    }
  }

  function IsReset() { return ResetCheckbox().is(":checked"); }

  function ShowReset(showReset: boolean) {
    Dialog.BoundForm.Container().find("[data-totp]").toggle(!showReset);
    Dialog.BoundForm.Container().find("[data-reset]").toggle(showReset);
  }

  namespace Server {
    let SessionGuid: string;

    export function Post<TResponse extends G2.ServerResponse>(request: G2.ClientSessionRequest): Promise<TResponse> {
      request.sessionGuid = SessionGuid;
      return new G2.Handler("LoginHandler").Post(request);
    }

    export function SetSessionGuid(sessionGuid: string) {
      SessionGuid = sessionGuid;
    }
  } // namespace Server


}